/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import { MUTATION_INTER_SET_DATA, ACTION_PAY_APPT_IMG_TEXT } from "@/store/mutation_types";
import { TestCallbackWechatOrder } from "@/api";
import Cons from "Constant"; // import func from 'vue-editor-bridge'

export default {
  data: function data() {
    return {
      orderObj: {},
      childClinicId: "",
      payPrice: "",
      apptRecordId: "",
      intervalPayToIm: null
    };
  },
  created: function created() {
    var _this = this;

    var apptRecordId = this.$router.currentRoute.query.orderNo;
    this.apptRecordId = apptRecordId;
    this.childClinicId = this.$router.currentRoute.query.childClinicId;
    this.payPrice = this.$router.currentRoute.query.price;
    this.ACTION_PAY_APPT_IMG_TEXT({
      bizPayOrderId: apptRecordId,
      childClinicId: this.childClinicId
    }).then(function (data) {
      _this.orderObj = data;

      if (Cons.ENV_PRODUCT) {
        _this.onBridgeReady();
      }
    })["catch"](function (res) {
      console.log(res.data.errorMsg);
      Public.dialog({
        content: "生成微信订单失败，请重新提交"
      });
    });
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapState({
    addRegInfo: function addRegInfo(state) {
      return state.apptReg.addRegInfo;
    }
  })),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions([ACTION_PAY_APPT_IMG_TEXT])), mapMutations({
    MUTATION_INTER_SET_DATA: MUTATION_INTER_SET_DATA
  })), {}, {
    /**
     * 支付事件调用
     */
    payEvent: function payEvent() {
      if (Cons.ENV_PRODUCT) {
        this.onBridgeReady();
      } else {
        this.testAjax();
      }
    },

    /**
     * 微信JSBridge调用支付
     */
    onBridgeReady: function onBridgeReady() {
      var that = this;

      function onBridgeReady() {
        WeixinJSBridge.invoke("getBrandWCPayRequest", {
          appId: that.orderObj.appId,
          //公众号名称，由商户传入
          timeStamp: that.orderObj.timeStamp,
          //时间戳，自1970年以来的秒数
          nonceStr: that.orderObj.nonceStr,
          //随机串
          "package": that.orderObj["package"],
          signType: that.orderObj.signType,
          //微信签名方式：
          paySign: that.orderObj.paySign //微信签名

        }, function (res) {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            Public.closeWin();
          }
        });
      }

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    },

    /**
     * test
     */
    testAjax: function testAjax() {
      var _this2 = this;

      var that = this;
      var fee = that.payPrice ? that.payPrice * 100 : 1;
      var clinicId = this.childClinicId || Utils.getSessionCache(Cons.CLINIC_ID);
      var apptRecordId = this.apptRecordId;
      var param = "<xml>" + "<appid><![CDATA[wxe28f055ef4a4f2e3]]></appid>" + "<bank_type><![CDATA[CFT]]></bank_type>" + "<cash_fee><![CDATA[1]]></cash_fee>" + "<fee_type><![CDATA[CNY]]></fee_type>" + "<is_subscribe><![CDATA[Y]]></is_subscribe>" + "<mch_id><![CDATA[1411408002]]></mch_id>" + "<nonce_str><![CDATA[skUsc6k1dWl0Y0zY]]></nonce_str>" + "<sub_openid><![CDATA[o_cTjvp_VV31K2BzPdvM6P32HvI0]]></sub_openid>" + "<out_trade_no><![CDATA[" + apptRecordId + "]]></out_trade_no>" + "<result_code><![CDATA[SUCCESS]]></result_code>" + "<return_code><![CDATA[SUCCESS]]></return_code>" + "<sign><![CDATA[B5833A51C221930E20C0D47204EEC0AD]]></sign>" + "<time_end><![CDATA[20170106094345]]></time_end>" + " <total_fee>" + fee + "</total_fee>" + " <trade_type><![CDATA[JSAPI]]></trade_type>" + "<transaction_id><![CDATA[4008322001201701065359601611]]></transaction_id>" + "<attach><![CDATA[scrm_img_text_pay|" + clinicId + "]]></attach>" + "<sub_appid><![CDATA[wx09965e12f4671732]]></sub_appid>" + "</xml>";
      TestCallbackWechatOrder(param, Cons.SCRM_WEB_SERVER_PATH + "open/pay/notify").then(function () {
        Public.tips({
          text: "测试模拟支付回调消息成功"
        });
        Public.closeWin(); // 支付跳转到问诊页面

        _this2.$router.push({
          name: "",
          query: {}
        });
      });
    },
    // 立即进入问诊
    onNextRouter: function onNextRouter() {
      if (this.intervalPayToIm) {
        window.clearInterval(this.intervalPayToIm);
      } //目前先写死 应该是在新增的订单的时候配置


      this.$store.commit(MUTATION_INTER_SET_DATA, {
        name: "inqueryId",
        value: this.$router.currentRoute.query.inqueryId
      });
      this.$router.replace({
        name: "INTER_IM",
        query: {
          inqueryId: this.$router.currentRoute.query.inqueryId,
          // 问诊id
          fromPay: "yes"
        }
      })["catch"](function (err) {});
    }
  })
};